import React, {Component} from 'react';
import "../../css/style-chart.css";
import Api from "../../utils/Api";
import Job from "../../utils/Job";
import CSVDownloadButton from "../../utils/CSVDownloadButton";
import TimeRange from "../../utils/TimeRange";
import DesignSelector from "../../globalComponents/DesignSelector";
import TableContainer from "../../utils/TableContainer";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import CheckBoxField from "../../utils/CheckBoxField";
import StaticFunctions from "../../utils/StaticFunctions";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import moment from "moment/moment";
import ShiftSelector from "../../globalComponents/ShiftSelector";

class CommandGetThreadbreaks extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;
        this.resizeTimer = null;

        this.state = {
            reportStatus: null,
            reportParams: null,
            designs: [],
            timeRange: null, // TimeRange
            showSubThreadbreaks: false,
            selectedDesign1: null,
            selectedDesign2: null,
            selectedMachine: null,
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            initialParams: null,
            requestedParams: null, // stringified parameters to prevent double-request
            chartAreaWidth: 800,
            chartData1: null,
            chartData2: null,
            errorData: null
        };

        this.reportKey = 'threadbreaksByDesign';

        this.updateDesigns = this.updateDesigns.bind(this);
        this.requestReport = this.requestReport.bind(this);
        this.designSelected = this.designSelected.bind(this);
        this.reportResult = this.reportResult.bind(this);
        this.updateDimensions = this.updateDimensions.bind(this);
        this.updateTables = this.updateTables.bind(this);
        this.toggleCheckBox = this.toggleCheckBox.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);

        this.updateDesignsJob = new Job(this.updateDesigns, 2000);

    }

    componentWillMount() {

        this.updateDesignsJob.start();

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));
        if (tr && tr.isValid()) newState.timeRange = tr;

        // Design1 aus den userprops laden
        const design1 = this.getReportSetting('design1');

        if (design1) newState.selectedDesign1 = design1;

        // Design2 aus den userprops laden
        const design2 = this.getReportSetting('design2');

        if (design2) newState.selectedDesign2 = design2;

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            const shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        // ShowSubThreadbreaks aus den userprops laden
        const showSubThreadbreaks = this.getReportSetting('showSubThreadbreaks', false);

        if (showSubThreadbreaks) newState.showSubThreadbreaks = true;

        if (newState) {
            this.setState(newState);
        }

    }

    componentDidMount() {

        this.updateDesigns();
        this.updateDimensions();

        window.addEventListener("resize", this.updateDimensions);

    }

    componentWillUnmount() {

        this.updateDesignsJob.stop();

        window.removeEventListener("resize", this.updateDimensions);

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.baseData.companies && nextProps.baseData.companies.currentCompany) {
            if (nextProps.baseData.companies.currentCompany.id !== this.state.currentCompanyId) {
                this.setState({
                    chartData1: null,
                    chartData2: null,
                    selectedDesign1: null,
                    selectedDesign2: null,
                    requestedParams: null,
                    currentCompanyId: nextProps.baseData.companies.currentCompany.id
                });
            }
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    updateDesigns() {

        const params = {
            "id_company": this.props.baseData.companies.currentCompany.id,
            'maxRows': this.state.maxEntries,
            'offset': this.state.maxEntries * this.state.currentPage
        };

        const strParams = JSON.stringify(params);

        if (this.sentParams === strParams) return;

        const callback = function(res) {
            if (res) {
                this.setState({
                    designs: res
                });
            }
        }.bind(this);

        this.api.request('GetDesigns', params, callback, null);
        this.sentParams = strParams;

    }

    updateDimensions() {

        const adjust = () => {
            try {
                this.resizeTimer = 0;
                // try to adjust chart width
                const newWidth = this.refs.chartArea.offsetWidth > 300 ? this.refs.chartArea.offsetWidth : 300;

                if (newWidth !== this.state.chartAreaWidth) {
                    this.setState({chartAreaWidth: newWidth});
                }
            } catch (e) {
            }
        };

        if (this.resizeTimer === null) adjust();
        if (this.resizeTimer > 0) window.clearTimeout(this.resizeTimer);

        this.resizeTimer = window.setTimeout(adjust, 75);

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const machineIds = this.props.machines.getAllMachineIds();
        const design1 = this.state.selectedDesign1;
        const design2 = this.state.selectedDesign2;

        // Check, if all data is set
        if (!dateFrom || !dateTill || !design1 || !design2 || machineIds.length === 0) return;
        if (!dateFrom.isValid() || !dateTill.isValid()) return;

        return {
            designs: [design1, design2],
            machineIds: machineIds,
            companyId: this.props.baseData.companies.currentCompany.id,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            showSubThreadbreaks: this.state.showSubThreadbreaks,
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                const chartData1 = res[0];
                const chartData2 = res[1];

                if (res) {
                    this.setState({
                        reportStatus: 'ready',
                        chartData1: chartData1,
                        chartData2: chartData2,
                        errorData: null,
                    });
                }
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    chartData1: null,
                    chartData2: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            chartData1: null,
            chartData2: null,
            errorData: null,
        }, () => {
            this.api.request('ReportThreadbreaksByDesign', params, callback, error);
        });

    }

    updateTables() {

        if (this.state.reportStatus === 'requested') return null;

        this.requestReport(this.state.selectedDesign1, 'chartData1');
        this.requestReport(this.state.selectedDesign2, 'chartData2');

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    designSelected(design) {

        let settingName = 'design';

        if (design.name === 'design-select-1') {
            settingName = 'design1';

            this.setState({
                selectedDesign1: {id: design.designId, stitches: design.stitches}
            });
        } else if (design.name === 'design-select-2') {
            settingName = 'design2';

            this.setState({
                selectedDesign2: {id: design.designId, stitches: design.stitches}
            });
        } else {
            this.setState({
                selectedDesign: {id: design.designId, stitches: design.stitches}
            });
        }

        // Safe Design-ID to Userconfig
        if (this.saveSettings && design) {
            this.saveSettings('reports', {report: this.reportKey, key: settingName, value: JSON.stringify({id: design.designId, stitches: design.stitches})});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    toggleCheckBox(fieldName, isChecked) {

        const state = {...this.state};

        state[fieldName] = isChecked;

        this.setState(state);

        // Safe option to Userconfig
        if (this.saveSettings && isChecked !== null) {
            this.saveSettings('reports', {report: this.reportKey, key: fieldName, value: isChecked});
        }

    }

    getErrorBlock(data, design) {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (design === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (data === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (data && data.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            const timeRange = this.state.reportParams.timeRange;

            csvContent.csvTitle.push(this.getChartHeadline(timeRange));

            csvContent.csvColumns.push(this.getCsvOverviewColumns());
            csvContent.csvData.push(this.getCsvOverviewRows());

            csvContent.csvColumns.push(this.getCsvTableColumns());
            csvContent.csvData.push(this.getCsvTableRows());
        }

        return csvContent;

    }

    getCsvOverviewColumns() {

        return [
            {
                key:  'label',
                name: ' ',
            },
            {
                key:  'firstValue',
                name: ' ',
            },
            {
                key: 'emptyColumn',
                name: ' ',
            },
            {
                key:  'label',
                name: ' ',
            },
            {
                key:  'secondValue',
                name: ' ',
            },
        ];

    }

    getCsvOverviewRows() {

        const chartData = [];
        const chartData1 = (this.state.chartData1) ? this.state.chartData1 : null;
        const chartData2 = (this.state.chartData2) ? this.state.chartData2 : null;

        if (chartData1 || chartData2) {
            const stitches1 = (chartData1) ? ((chartData1.pieces > 0) ? (chartData1.designStitches * chartData1.pieces) : 0) : 0;
            const threadbreaks1 = ((chartData1)) ? chartData1.threadbreaks : 0;
            const threadbreaksByRatio1 = StaticFunctions.calcThreadbreaksByRatio(stitches1, threadbreaks1);

            const stitches2 = (chartData2) ? ((chartData2.pieces > 0) ? (chartData2.designStitches * chartData2.pieces) : 0) : 0;
            const threadbreaks2 = (chartData2) ? chartData2.threadbreaks : 0;
            const threadbreaksByRatio2 = StaticFunctions.calcThreadbreaksByRatio(stitches2, threadbreaks2);

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('designId'),
                firstValue: (chartData1) ? chartData1.designId : ' ',
                secondValue: (chartData2) ? chartData2.designId : ' '
            });

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('designStitches'),
                firstValue: (stitches1) ? StaticFunctions.formatedNumber(chartData1.designStitches) : 0,
                secondValue: (stitches2) ? StaticFunctions.formatedNumber(chartData2.designStitches) : 0
            });

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('totalStitches'),
                firstValue: (stitches1) ? StaticFunctions.formatedNumber(stitches1) : 0,
                secondValue: (stitches2) ? StaticFunctions.formatedNumber(stitches2) : 0
            });

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('threadbreaks'),
                firstValue: (threadbreaks1) ? StaticFunctions.formatedNumber(threadbreaks1) : 0,
                secondValue: (threadbreaks2) ? StaticFunctions.formatedNumber(threadbreaks2) : 0
            });

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('numberOfPieces'),
                firstValue: (chartData1) ? StaticFunctions.formatedNumber(chartData1.pieces) : 0,
                secondValue: (chartData2) ? StaticFunctions.formatedNumber(chartData2.pieces) : 0
            });

            chartData.push({
                emptyColumn: ' ',
                label: this.translate('threadBreaksPer10KStiches'),
                firstValue: StaticFunctions.formatedNumber((threadbreaksByRatio1) ? threadbreaksByRatio1 : 0, 2),
                secondValue: StaticFunctions.formatedNumber((threadbreaksByRatio2) ? threadbreaksByRatio2 : 0, 2)
            });
        }

        return chartData;

    }

    getCsvTableColumns() {

        return [
            {
                key:  'firstSt',
                nameKey: 'stitch',
            },
            {
                key:  'firstTb',
                nameKey: 'threadbreaks',
            },
            {
                key: 'emptyColumn',
                name: ' ',
            },
            {
                key:  'secondSt',
                nameKey: 'stitch',
            },
            {
                key:  'secondTb',
                nameKey: 'threadbreaks',
            },
        ];

    }

    getCsvTableRows() {

        const chartData = [];
        const chartData1 = (this.state.chartData1) ? this.state.chartData1.threadbreakList : [];
        const chartData2 = (this.state.chartData2) ? this.state.chartData2.threadbreakList : [];
        const chartDataLength = (chartData1.length > chartData2.length) ? chartData1.length : chartData2.length;

        for (let i = 0; i < chartDataLength; i++) {
            let dataTemp1 = (chartData1[i] !== undefined) ? chartData1[i] : null;
            let dataTemp2 = (chartData2[i] !== undefined) ? chartData2[i] : null;
            let dataOpt = {
                emptyColumn: ' ',
                firstSt: (dataTemp1) ? StaticFunctions.formatedNumber(dataTemp1.stitch) : ' ',
                firstTb: (dataTemp1) ? StaticFunctions.formatedNumber(dataTemp1.threadbreaks) : ' ',
                secondSt: (dataTemp2) ? StaticFunctions.formatedNumber(dataTemp2.stitch) : ' ',
                secondTb: (dataTemp2) ? StaticFunctions.formatedNumber(dataTemp2.threadbreaks) : ' ',
            };

            chartData.push(dataOpt);
        }

        return chartData;

    }

    getTableColumns() {

        return [
            {
                key: 'stitch',
                nameKey: 'stitch',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key:  'threadbreaks',
                nameKey: 'threadbreaks',
                classes: 'text-right',
                sortType: 'int',
            },
        ];

    }

    getTableRows(data = []) {

        const rows = [];

        if (data) {
            for (let i = 0; i < data.length; i++) {
                let rowTemp = data[i];

                rows.push({
                    id: rowTemp.stitch,
                    stitch: StaticFunctions.formatedNumber(rowTemp.stitch),
                    threadbreaks: StaticFunctions.formatedNumber(rowTemp.threadbreaks),
                });
            }
        }

        return rows;

    }

    getRemainingDesigns(usedDesigns = []) {

        const allDesigns = (this.state.designs) ? this.state.designs : [];

        return allDesigns.filter(
            (design) => {
                return !usedDesigns.includes(design.id);
            }
        );

    }

    reportResult(result, selectedField) {

        const newState = {};

        newState['reportStatus'] = 'ready';
        newState[selectedField] = result;

        this.setState(newState);

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            firstDesign: (this.state.reportParams.selectedDesign1) ? this.state.reportParams.selectedDesign1 : null,
            firstDesignTitle: this.translate('firstDesign'),
            secondDesign: (this.state.reportParams.selectedDesign2) ? this.state.reportParams.selectedDesign2 : null,
            secondDesignTitle: this.translate('secondDesign'),
			stitchesUnit: this.translate('stitches'),
			allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getDesignHeader(timeRange) {

        if (!this.state.chartData1 && !this.state.reportParams.chartData2) return null;

        const headline = this.getChartHeadline(timeRange);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    renderTable(data) {

        if (!data || data.length === 0) return null;

        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows(data);

        return (
            <div>
                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                    fillGaps="0"
                    maxWidth={500}
                />
            </div>
        );

    }

    renderDesignBlock(data, design) {

        const errorBlock = this.getErrorBlock(data, design);

        if (errorBlock !== null) return null;

        const stitches = (data.pieces > 0) ? (data.designStitches * data.pieces) : 0;
        const threadbreaks = data.threadbreaks || 0;
        const threadbreaksByRatio = StaticFunctions.calcThreadbreaksByRatio(stitches, threadbreaks);
        const tableArea = this.renderTable(data.threadbreakList);

        return (
            <div className="col-sm-4">
                <div className="formRow ma-bo-10">
                    <table>
                        <tbody>
                            <tr>
                                <td className="text-left labelSpan">{this.translate('designId')}</td>

                                <td className="text-left">
                                    <input
                                        name="designId"
                                        type="text"
                                        value={data.designId}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('designStitches')}</td>

                                <td className="text-left">
                                    <input
                                        name="stitches"
                                        type="text"
                                        value={StaticFunctions.formatedNumber(data.designStitches)}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('totalStitches')}</td>

                                <td className="text-left">
                                    <input
                                        name="stitches"
                                        type="text"
                                        value={StaticFunctions.formatedNumber(stitches)}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('threadbreaks')}</td>

                                <td className="text-left">
                                    <input
                                        name="threadbreaks"
                                        type="text"
                                        value={StaticFunctions.formatedNumber(threadbreaks)}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('numberOfPieces')}</td>

                                <td className="text-left">
                                    <input
                                        name="pieces"
                                        type="text"
                                        value={StaticFunctions.formatedNumber(data.pieces)}
                                        disabled={true}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td className="text-left labelSpan">{this.translate('threadBreaksPer10KStiches')}</td>

                                <td className="text-left">
                                    <input
                                        name="threadBreaksPer10KStiches"
                                        type="text"
                                        value={StaticFunctions.formatedNumber(threadbreaksByRatio, 2)}
                                        disabled={true}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="ma-bo-10">
                    {tableArea}
                </div>
            </div>
        );

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const designHeader = this.getDesignHeader(this.state.reportParams.timeRange);

        const errorBlock1 = this.getErrorBlock(this.state.chartData1, this.state.reportParams.selectedDesign1);
        const errorBlock2 = this.getErrorBlock(this.state.chartData2, this.state.reportParams.selectedDesign2);

        if (errorBlock1 !== null) return errorBlock1;
        if (errorBlock2 !== null) return errorBlock2;

        const designBlock1 = this.renderDesignBlock(this.state.chartData1, this.state.reportParams.selectedDesign1);
        const designBlock2 = this.renderDesignBlock(this.state.chartData2, this.state.reportParams.selectedDesign2);

        return (
            <div>
                {designHeader}

                {designBlock1}

                {designBlock2}
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const firstDesigns = this.getRemainingDesigns([this.state.selectedDesign2]);
        const secondDesigns = this.getRemainingDesigns([this.state.selectedDesign1]);

        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        this.getCsvOverviewRows();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('firstDesign')}</h4>

                                <div>
                                    <DesignSelector
                                        name="design-select-1"
                                        baseData={this.props.baseData}
                                        currentDesign={this.state.selectedDesign1}
                                        designs={firstDesigns}
                                        translate={this.translate}
                                        onDesignSelected={(design) => this.designSelected(design)}
                                    />
                                </div>
                            </div>

                            <div className="ma-bo-10">
                                <h4>{this.translate('secondDesign')}</h4>

                                <div>
                                    <DesignSelector
                                        name="design-select-2"
                                        baseData={this.props.baseData}
                                        currentDesign={this.state.selectedDesign2}
                                        designs={secondDesigns}
                                        translate={this.translate}
                                        onDesignSelected={(design) => this.designSelected(design)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        translate={this.translate}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>

                            <div className="formSettings ma-bo-10">
                                <h4>{this.translate('options')}</h4>

                                <div className="formBox">
                                    <CheckBoxField
                                        name="showSubThreadbreaks"
                                        label={this.translate('showSubThreadbreaks')}
                                        isChecked={this.state.showSubThreadbreaks}
                                        onChange={this.toggleCheckBox}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="formSettings clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default CommandGetThreadbreaks;
